module.exports = __webpack_public_path__ + "img/basic_restorejel.9059a45d.jpg";